import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { loadStoreSettings } from "../../util/storeSettings";

function whatsappHref(settings) {
  const raw = String(settings?.whatsappNumber || "").trim();
  if (!raw) return "";
  if (/^https?:/i.test(raw)) return raw;
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("0")) digits = `92${digits.slice(1)}`;
  if (!digits) return "";
  return `https://wa.me/${digits}`;
}

export default function WhatsAppButton() {
  const [href, setHref] = useState("");

  useEffect(() => {
    let mounted = true;
    const apply = (settings) => {
      const next = whatsappHref(settings);
      if (mounted && next) setHref(next);
    };

    try {
      const cached = JSON.parse(localStorage.getItem("store_settings") || "null");
      if (cached) apply(cached);
    } catch {
      /* ignore a bad cache */
    }

    loadStoreSettings()
      .then((settings) => {
        if (settings) apply(settings);
      })
      .catch(() => {});

    return () => {
      mounted = false;
    };
  }, []);

  if (!href) return null;

  return (
    <a
      className="store-whatsapp"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
